/* @flow */
import * as React from 'react';

import styles from './styles.module.scss';

type Props = {
  title?: string,
  label?: React.Node,
  children?: React$Element<any>,
  meta?: any,
};

const InputSelect = (props: Props): React$Element<any> => {
  const { label, title, children, meta, ...rest } = props;
  return (
    <label className={styles.container}>
      <div className={styles.label}>{label}</div>
      <select
        className={styles.input}
        title={title || (typeof label === 'string' ? label : undefined)}
        {...rest}
      >
        {children}
      </select>
    </label>
  );
};

export default InputSelect;
